// Dependencies imports
import React, { useEffect, useState,useCallback } from "react";
import {
  DataGrid,
  // GridToolbar,
  GridToolbarContainer,
  
GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,

  GridToolbarExport ,
} from "@mui/x-data-grid";

import Paper from "@mui/material/Paper";
import { awsSignIn, authData } from "../../../redux/auth/authSlice";
import Modal from "@mui/material/Modal";
//import Fade from "@mui/material/Fade";
//import Backdrop from "@mui/material/Backdrop";

// Local imports
import { Constants } from "../../../config/Constants";
import config from "../../../config/aws-exports";
import { API } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import { useSelector, useDispatch } from "react-redux";
import AddTenant from "./AddTenant";
import { ReactComponent as Delete } from "../../../assets/icons/delete_black_24dp.svg";
import { ReactComponent as Edit } from "../../../assets/icons/edit_black_24dp.svg";
import Button from "@mui/material/Button";
import EditTenant from './EditTenant';
import DeleteTenant from'./DeleteTenant' ;

// Style imports
import Ten from "./Tenants.module.scss";
//import { Box } from "@mui/material";

// Custom Toolbard to export and filter for datagrid
function CustomToolbar() {
  return (
    <GridToolbarContainer
      style={{ display: "flex", justifyContent: "flex-end" }}
    >
      {/* <GridToolbar /> */}
      
<GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />

      <GridToolbarExport
      csvOptions={{
        fileName: `Organizations-${new Date()
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-")}`,
        utf8WithBom: true,
      }}
    />
    </GridToolbarContainer>
  );
}



// Start of main Tenant Component
export default function Tenants() {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  //const classes = useStyles();
  const navigate = useNavigate();
  const [editData, setEditData] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  const dispatch = useDispatch();
  //const [tenants, setTenants] = useState([]);

  let userDetails = useSelector(authData);
  console.log("data", userDetails);

  //  const handleDeleteClick = (param, event) => {
  //   handleDeleteOpen();
  //   console.log("param" , param.row)
  //   setDeleteData(param.row);
  // };
  //   const handleCellClick = (param) => {
  //   console.log("param", param);
  //   console.log("param row", param.row);

  //   let sdata = { ...userDetails };
  //   sdata.tenantdata= param.row;
  //   sdata.tenantOID = param.row.st_id;

  //   if (sdata.breadcrumb === undefined) {
  //     sdata.breadcrumb = [];
  //     let temp = [...sdata.breadcrumb];
  //     temp[0] = {
  //       name: "Organizations",
  //       path: "/organization",
  //     };
  //     temp[1] = {
  //       name: param.row.tenant,
  //       path: "/organization/viewTenant",
  //     };
  //     sdata.breadcrumb = temp;
  //   } else {
  //     let temp = [...sdata.breadcrumb];
  //     temp[0] = {
  //       name: "Organizations",
  //       path: "/organization",
  //     };
  //     temp[1] = {
  //       name: param.row.tenant,
  //       path: "/organization/viewTenant",
  //     };

  //     sdata.breadcrumb = temp;
  //   }
  //   dispatch(awsSignIn(sdata));

  //   navigate("/organization/viewTenant");
  //   // console.log(event);
  // };

  //   const handleEditClick = (param, event) => {
  //   handleEditOpen();
  //   console.log("param edit", param.row);
  //   setEditData(param.row);
  // };

  const handleDeleteOpen = useCallback(() => {
    setOpenDelete(true);
  }, []);

  const handleEditOpen = useCallback(() => {
    setOpenEdit(true);
  }, []);

  const handleDeleteClick = useCallback(
    (param, event) => {
      handleDeleteOpen();
      console.log("param", param.row);
      setDeleteData(param.row);
    },
    [handleDeleteOpen],
  );

  const handleEditClick = useCallback(
    (param, event) => {
      handleEditOpen();
      console.log("param edit", param.row);
      setEditData(param.row);
    },
    [handleEditOpen],
  );

  const handleCellClick = useCallback(
    (param) => {
      console.log("param", param);
      console.log("param row", param.row);

      let sdata = { ...userDetails };
      sdata.tenantdata = param.row;
      sdata.tenantOID = param.row.st_id;

      let temp = [];
      temp[0] = {
        name: "Organizations",
        path: "/organization",
      };
      temp[1] = {
        name: param.row.tenant,
        path: "/organization/viewTenant",
      };

      sdata.breadcrumb = temp;

      dispatch(awsSignIn(sdata));
      navigate("/organization/viewTenant");
    },
    [userDetails, dispatch, navigate],
  );

  const getTenants = useCallback(async () => {
    setLoading(true);
    const bodyParam = {
      body: {
        org: config.aws_org_id,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const tenants = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_TENANT_DATA,
        bodyParam,
      );
      //alert("tenants", JSON.stringify(tenants));
      const tenantsAll = tenants.body.viewData;
      let trows = [];

      for (let i = 0; i < tenantsAll.length; i++) {
        let obj = {};
        obj.id = i;
        obj.tenant = tenantsAll[i].displayname;
        obj.userCount = tenantsAll[i].user_cnt;
        obj.otenant = tenantsAll[i].oid;
        obj.st_id = tenantsAll[i].st_id;
        obj.iphoneusers = tenantsAll[i].ios_cnt;
        obj.androidusers = tenantsAll[i].android_cnt;
        obj.webusers = tenantsAll[i].web_cnt;
        obj.tenantname = tenantsAll[i].tenantname;
        trows.push(obj);
      }

      const tcolumns = [
        {
          field: "tenant",
          headerName: "Organizations",
          flex: 1,
          headerClassName: `${Ten.rootHeader}`,
          renderCell: (param) => {
            return (
              <h3 onClick={() => handleCellClick(param)} className={Ten.head}>
                {param.value}
              </h3>
            );
          },
        },
        {
          field: "userCount",
          headerName: "No of users",
          flex: 1,
          headerClassName: `${Ten.rootHeader}`,
        },
        {
          field: "edit",
          headerName: "Edit Organization",
          flex: 1,
          sortable: false,
          disableExport: true,
          disableClickEventBubbling: true,
          headerClassName: `${Ten.rootHeader}`,
          renderCell: (param) => {
            return (
              <Button
                size="small"
                // style={{ color: "white", background: config.main_color_1, fontSize: "12px", fontWeight: "bold" }}
                startIcon={<Edit />}
                onClick={(event) => {
                  handleEditClick(param, event);
                }}
              ></Button>
            );
          },
        },
        {
          field: "delete",
          headerName: "Delete Organization",
          flex: 1,
          sortable: false,
          disableExport: true,
          disableClickEventBubbling: true,
          headerClassName: `${Ten.rootHeader}`,
          renderCell: (param) => {
            return (
              <Button
                size="small"
                // style={{ color: "white", background: "#f32013", fontSize: "12px", fontWeight: "bold" }}
                startIcon={<Delete />}
                onClick={(event) => {
                  handleDeleteClick(param, event);
                }}
              ></Button>
            );
          },
        },
      ];
      //alert(JSON.stringify(trows));
      setRows(trows);
      setColumns(tcolumns);
      setLoading(false);
      //setTenants(tenants.body);
    } catch (error) {
      console.error(error);
    }
  }, [handleCellClick, handleDeleteClick, handleEditClick]); // ✅ empty array means stable reference

  useEffect(() => {
    getTenants();
    return () => {};
  }, [getTenants]);

  const handleAddOpen = () => {
    setOpenAdd(true);
  };

  const handleAddClose = () => {
    setOpenAdd(false);
  };

  const handleDeleteClose = () => {
    setOpenDelete(false);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  // async function getTenants() {
  //   setLoading(true);
  //   const bodyParam = {
  //     body: {
  //       org: config.aws_org_id,
  //       schema: Constants.SCHEMA_NAME
  //     },
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //   };
  //   try {
  //     console.log(bodyParam.body);
  //     const tenants = await API.post(
  //       config.aws_cloud_logic_custom_name,
  //       Constants.GET_TENANT_DATA,
  //       bodyParam
  //     );
  //     //alert("tenants", JSON.stringify(tenants));
  //     const tenantsAll = tenants.body.viewData;
  //     let trows = [];

  //     for (let i = 0; i < tenantsAll.length; i++) {
  //       let obj = {};
  //       obj.id = i;
  //       obj.tenant = tenantsAll[i].displayname;
  //       obj.userCount = tenantsAll[i].user_cnt;
  //       obj.otenant = tenantsAll[i].oid;
  //       obj.st_id = tenantsAll[i].st_id;
  //       obj.iphoneusers = tenantsAll[i].ios_cnt;
  //       obj.androidusers = tenantsAll[i].android_cnt;
  //       obj.webusers = tenantsAll[i].web_cnt;
  //       obj.tenantname = tenantsAll[i].tenantname;
  //       trows.push(obj);
  //     };

  //     const tcolumns = [
  //       {
  //         field: "tenant",
  //         headerName: "Organizations",
  //         flex: 1,
  //         headerClassName: "super-app-theme--header",
  //         renderCell: (param) => {
  //           return (
  //             <h3 onClick={() => handleCellClick(param)} className={Ten.head}>{param.value}</h3>
  //           );
  //         }
  //       },
  //       {
  //         field: "userCount",
  //         headerName: "No of users",
  //         flex: 1,
  //         headerClassName: "super-app-theme--header",
  //       },
  //       {
  //         field: "edit",
  //         headerName: "Edit Organization",
  //         flex: 1,
  //         sortable: false,
  //         disableExport: true,
  //         disableClickEventBubbling: true,
  //         headerClassName: "super-app-theme--header",
  //         renderCell: (param) => {
  //           return (
  //             <Button
  //               size="small"
  //               // style={{ color: "white", background: config.main_color_1, fontSize: "12px", fontWeight: "bold" }}
  //               startIcon={<Edit />}
  //               onClick={(event) => {
  //                 handleEditClick(param, event);
  //               }}
  //             ></Button>
  //           );
  //         },
  //       },
  //       {
  //         field: "delete",
  //         headerName: "Delete Organization",
  //         flex: 1,
  //         sortable: false,
  //         disableExport: true,
  //         disableClickEventBubbling: true,
  //         headerClassName: "super-app-theme--header",
  //         renderCell: (param) => {
  //           return (
  //             <Button
  //               size="small"
  //               // style={{ color: "white", background: "#f32013", fontSize: "12px", fontWeight: "bold" }}
  //               startIcon={<Delete />}
  //               onClick={(event) => {
  //                 handleDeleteClick(param, event);
  //               }}
  //             ></Button>
  //           );
  //         },
  //       },
  //     ];
  //     //alert(JSON.stringify(trows));
  //     setRows(trows);
  //     setColumns(tcolumns);
  //     setLoading(false);
  //     //setTenants(tenants.body);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // Start of main return
  return (
    <div className={Ten.main}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={Ten.modal}
        open={openAdd}
        //closeAfterTransition
        //BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={openAdd}>
          <Box sx={{ p: 2 }}> */}
            <AddTenant
              handleAddClose={handleAddClose}
              getTenants={getTenants}
            />
          {/* </Box>
        </Fade> */}
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={Ten.modal}
        open={openEdit}
        //closeAfterTransition
        //BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={openEdit}>
          <Box sx={{ p: 2 }}> */}
            <EditTenant
              handleEditClose={handleEditClose}
              editData={editData}
              getTenants={getTenants}
            />
          {/* </Box>
        </Fade> */}
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={Ten.modal}
        open={openDelete}
        //closeAfterTransition
        //BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={openDelete}>
          <Box sx={{ p: 2 }}> */}
            <DeleteTenant
              handleDeleteClose={handleDeleteClose}
              deleteData={deleteData}
              getTenants={getTenants}
            />
          {/* </Box>
        </Fade> */}
      </Modal>
      <div className={Ten.buttonholder}>
        <button className={Ten.addbutton} onClick={handleAddOpen}>
          Add Organization
        </button>
      </div>
      <Paper>
        <div
          style={{ height: 600, width: "100%", overflowY: "auto" }}
          //className={Ten.rootHeader}
        >
          {loading === false ? (
            <DataGrid
              rows={rows}
              columns={columns}
              className={Ten.MuiDataGridRoot}
              slots={{
                toolbar: CustomToolbar,
              }}
              disableSelectionOnClick
            />
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Skeleton variant="rect" width="100%" height={600} />{" "}
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
}
